<template>
  <div class="app-footer">
    <div class="app-footer-content common-width">
      <div class="footer-company-info">
        <div class="titile0">上海洞见信息科技有限公司</div>

        <div v-for="(info, index) in companyInfo" :key="index">
          <img
            class="title-icon"
            :src="require('@/assets/images/' + info.infoSrc)"
          />
          <div class="titile1" v-html="info.title" />
        </div>
      </div>
      <div class="footer-user-info">
        <el-input v-model="username" placeholder="您的姓名" class="input0" />
        <el-input v-model="phone" placeholder="您的电话" class="input0" />
        <el-input v-model="email" placeholder="您的邮箱" class="input0" />
        <el-input
          v-model="leavingMsg"
          type="textarea"
          placeholder="留言内容"
          class="input2"
          rows="4"
          resize="none"
        />
        <div class="captcha-row">
          <el-input
            v-model="captchaCode"
            placeholder="验证码"
            class="captcha-input"
            @keyup.enter="submitClick()"
          />
          <img
            v-if="captchaImage"
            :src="'data:image/png;base64,' + captchaImage"
            class="captcha-img"
            @click="loadCaptcha"
            title="点击刷新验证码"
          />
          <span v-else class="captcha-loading" @click="loadCaptcha"
            >加载中...</span
          >
        </div>
        <el-button
          type="primary"
          class="submit-btn"
          :loading="submitting"
          @click="submitClick()"
          >提交</el-button
        >
      </div>

      <div class="footer-tip-area">
        <a class="footer-tip" @click="funcClick(productPath)">产品中心</a>
        <div class="footer-tip">&ensp;|&ensp;</div>
        <a class="footer-tip" @click="funcClick(newsPath)">新闻中心</a>
      </div>
      <div class="footer-copyright">
        Copyright © djxinxi.net 上海洞见信息科技有限公司版权所有
        沪ICP备2022020506号-1
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { publicApi } from "@/api/http";
import { ElMessage } from "element-plus";

export default {
  name: "FooterView",
  setup() {
    const router = useRouter();
    const username = ref("");
    const phone = ref("");
    const email = ref("");
    const leavingMsg = ref("");
    const submitting = ref(false);
    const captchaCode = ref("");
    const captchaImage = ref("");
    const captchaToken = ref("");

    function funcClick(routerPath) {
      router.push({ path: routerPath });
    }
    const productPath = "/product";
    const newsPath = "/news";
    const companyInfo = [
      {
        infoSrc: "footer-addess-icon.png",
        title: "地址：上海市闵行区莘松路855弄青春商务楼1号楼8422A",
      },
      {
        infoSrc: "footer-postal-icon.png",
        title: "邮编：200120",
      },
      {
        infoSrc: "footer-phone-icon.png",
        title: "手机：13918374630",
      },
      {
        infoSrc: "footer-email-icon.png",
        title: "邮件：zhanggong@djxinxi.net",
      },
    ];

    async function loadCaptcha() {
      try {
        const res = await publicApi.getCaptcha();
        if (res.code === 0) {
          captchaImage.value = res.data.image;
          captchaToken.value = res.data.token;
          captchaCode.value = "";
        }
      } catch (e) {
        console.error("加载验证码失败", e);
      }
    }

    async function submitClick() {
      if (!username.value || !phone.value || !leavingMsg.value) {
        ElMessage({ message: "请填写姓名、电话和留言内容", type: "warning" });
        return;
      }
      if (!captchaCode.value) {
        ElMessage({ message: "请输入验证码", type: "warning" });
        return;
      }
      submitting.value = true;
      try {
        const res = await publicApi.submitMessage({
          name: username.value,
          phone: phone.value,
          email: email.value,
          content: leavingMsg.value,
          vcode: captchaCode.value,
          vcodeToken: captchaToken.value,
        });
        if (res.code === 0) {
          username.value = "";
          phone.value = "";
          email.value = "";
          leavingMsg.value = "";
          captchaCode.value = "";
          ElMessage({ message: "留言提交成功", type: "success" });
          loadCaptcha();
        } else {
          ElMessage({ message: res.message || "提交失败", type: "error" });
          loadCaptcha();
        }
      } catch (e) {
        ElMessage({ message: "提交失败，请稍后重试", type: "error" });
        loadCaptcha();
      } finally {
        submitting.value = false;
      }
    }

    onMounted(() => {
      loadCaptcha();
    });

    return {
      funcClick,
      productPath,
      newsPath,
      companyInfo,
      username,
      phone,
      email,
      leavingMsg,
      submitClick,
      submitting,
      captchaCode,
      captchaImage,
      loadCaptcha,
    };
  },
};
</script>

<style scoped>
.app-footer {
  height: 540px;
  width: 100%;
  background-color: #363636;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding-top: 60px;
}

.app-footer-content {
  position: relative;
}

.footer-company-info {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  width: 605px;
}

.footer-user-info {
  width: 605px;
  position: absolute;
  right: 0;
}

.title-icon {
  display: inline-block;
}

.titile0 {
  color: #ffffff;
  font-size: 30px;
  line-height: 48px;
  margin-bottom: 20px;
}

.titile1 {
  color: #ffffff;
  font-size: 16px;
  line-height: 40px;
  display: inline-block;
  margin-left: 20px;
}
.input0 {
  width: 500px;
  height: 30px;
  margin-left: 50px;
  margin-top: 20px;
}
.input2 {
  width: 500px;
  height: 100px;
  margin-left: 50px;
  margin-top: 20px;
}
.input0:nth-child(1) {
  margin-top: 10px;
}
.footer-tip-area {
  position: absolute;
  width: 100%;
  bottom: 58px;
  display: flex;
  justify-content: center;
}

.footer-tip {
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.footer-copyright {
  color: white;
  text-align: center;
  position: absolute;
  font-size: 12px;
  width: 100%;
  bottom: 25px;
}
.captcha-row {
  display: flex;
  align-items: center;
  margin-left: 50px;
  margin-top: 12px;
  gap: 10px;
}
.captcha-input {
  width: 150px;
}
.captcha-img {
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
}
.captcha-loading {
  color: #999;
  font-size: 12px;
  cursor: pointer;
}
.submit-btn {
  margin-left: 50px;
  margin-top: 12px;
}
</style>
